import React, { useEffect } from "react";
import { NavigationBarReplacement as NavigationBar } from "../SidebarMenu/NavigationBarReplacement";
import { getDevice } from "../../../utils/device";

export type PageContainerProps = {
  header?: {
    content: any;
  };
  sidebar?: {
    content: any;
    width?: number;
    hidden?: boolean;
  };
  main?: {
    content: any;
  };
  isRunsheetBeta?: boolean;
};

export const PageContainer = ({
  header,
  sidebar,
  main,
  isRunsheetBeta = false
}: PageContainerProps) => {
  const device = getDevice();

  // Detect iOS and add platform class to body
  useEffect(() => {
    if (/iPad/.test(navigator.userAgent)) {
      document.body.classList.add("platform-ipad");
    } else if (/iPhone|iPod/.test(navigator.userAgent)) {
      document.body.classList.add("platform-ios");
    }
  }, []);

  const sidebarClasses = [
    "page-container-panel",
    "PageContainer__sidebar",
    "order-none flex-initial self-stretch content-stretch items-start flex",
    "z-[12] h-full",
    // border-r-0 kills the seam between sidebar and main;
    // border-l-0 kills the outer border that hugged the screen edge.
    "rounded-l-lg border-r-0 border-l-0",
    "transition-[transform,opacity] duration-300 ease-in-out",
    "translate-x-0 opacity-100",
    sidebar?.hidden
      ? "-translate-x-full opacity-0 pointer-events-none PageContainer__sidebar--hidden"
      : ""
  ]
    .filter(Boolean)
    .join(" ");

  const mainClasses = [
    "page-container-panel",
    "PageContainer__main",
    "flex-auto self-stretch flex flex-col",
    "h-full overflow-auto",
    // border-l-0 kills the seam between sidebar and main;
    // border-r-0 kills the outer border on the right screen edge.
    "rounded-br-lg border-l-0 border-r-0",
    "transition-[border-radius,border-left] duration-300 ease-in-out",
    isRunsheetBeta
      ? "rounded-tl-lg rounded-br-lg border-l border-border-color PageContainer__main--runsheet-beta"
      : ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="PageContainer__root flex h-full">
      <div className="PageContainer flex flex-col flex-nowrap justify-start content-stretch items-start bg-page-background flex-1 h-full w-full overflow-visible">
        {header && (
          <div className="PageContainer__header flex-initial self-stretch flex flex-row flex-nowrap justify-center content-start items-center z-[14] h-[60px] max-w-[100vw]">
            {header.content}
          </div>
        )}

        {/* flex-1 (flex: 1 1 0%) requires a fixed height chain from the root (h-full on PageContainer__root). Without it, the body collapses to zero height. */}
        <div className="PageContainer__body flex-1 flex flex-row flex-nowrap justify-start content-stretch w-full min-h-0">
          {device === "desktop" && <NavigationBar />}

          {sidebar && <div className={sidebarClasses}>{sidebar.content}</div>}

          {main && <div className={mainClasses}>{main.content}</div>}
        </div>
      </div>
    </div>
  );
};
